import { Component } from "@angular/core";

@Component({
  selector: "snt-report-form-renderer-empty",
  templateUrl: "report-form-renderer-empty.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererEmptyComponent {
  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "empty",
      config: {}
    };
  }
}
